import React from "react";

const BrandIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path d="M6.77575 20H2L8.3978 4H13.1736L6.77575 20Z" fill="#646F87" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.09583 19.0111L11.7028 4.98889H9.07772L3.47076 19.0111H6.09583ZM6.77575 20L13.1736 4H8.3978L2 20H6.77575Z"
        fill="#646F87"
      />
      <path d="M15.6019 20H10.8262L17.224 4H21.9997L15.6019 20Z" fill="#646F87" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.922 19.0111L20.529 4.98889H17.9039L12.2969 19.0111H14.922ZM15.6019 20L21.9997 4H17.224L10.8262 20H15.6019Z"
        fill="#646F87"
      />
    </svg>
  );
};

export default BrandIcon;
